<button
  mat-icon-button
  type="button"
  class="close-button"
  aria-label="Cerrar"
  (click)="close()"
>
  <mat-icon>close</mat-icon>
</button>
<h1 mat-dialog-title>Información del día</h1>
<div mat-dialog-content>
  <p *ngIf="data.props.locationName"><b>Ubicación:</b> {{ data.props.locationName }}</p>
  <p *ngIf="data.props.locationAddress"><b>Dirección:</b> {{ data.props.locationAddress }}</p>
  <p *ngIf="data.props.schedule"><b>Horario:</b> {{ data.props.schedule }}</p>

  <p *ngIf="isAttendanceRegistered" class="attendance-registered">
    <mat-icon class="attendance-registered__icon">check_circle</mat-icon>
    <span>Tu asistencia ya fue registrada satisfactoriamente.</span>
  </p>
</div>
<div mat-dialog-actions class="center" *ngIf="canShowAttendanceButton">
  <span [matTooltip]="isClassDay ? '' : NOT_CLASS_DAY_TOOLTIP">
    <button
      mat-button
      mat-raised-button
      class="attendance-button"
      cdkFocusInitial
      [disabled]="!isClassDay"
      (click)="openAttendanceModal()"
    >
      Dar asistencia
    </button>
  </span>
</div>
